/**
 * DOM -> HTML string.
 *
 * The one contract every consumer depends on: when the editor holds no text,
 * the emitted value is the empty string, even though the DOM still holds markup
 * (a `<p><br></p>` is what an "empty" contenteditable actually contains). Every
 * required-field check in the app is `value.length === 0`, so this must hold.
 */

/**
 * True when the node contains no visible text. `String.prototype.trim` also
 * strips non-breaking spaces, so a paragraph holding only `&nbsp;` counts as
 * empty -- which matches how the old editor's `innerText` check behaved.
 */
export function isTextless(root: Node): boolean {
  return (root.textContent ?? '').trim().length === 0;
}

/** Serializes the editable root to the string that gets stored. */
export function serialize(root: HTMLElement): string {
  if (isTextless(root)) {
    return '';
  }
  return root.innerHTML.trim();
}
